import React, {useEffect, useState} from 'react';
import { Button } from 'antd';
import dayjs from 'dayjs';

interface RocDatePickerProps {
    value?: dayjs.Dayjs;
    onChange?: (value: dayjs.Dayjs) => void;
    yearRange?: [number, number]; // 民國年範圍，例如 [90, 120]
    mode?: 'yyy-mm-dd' | 'yyy-mm';
}

const weekdays = ['日', '一', '二', '三', '四', '五', '六'];

const RocDateGridPicker: React.FC<RocDatePickerProps> = ({
                                                         value,
                                                         onChange,
                                                         yearRange = [100, 999], mode
                                                     }) => {
    const initial = dayjs.isDayjs(value) && value.isValid() ? value : dayjs();
    const [current, setCurrent] = useState<dayjs.Dayjs>(initial);

    const rocYear = current.year() - 1911;
    const month = current.month() + 1;
    const firstDay = dayjs(`${current.year()}-${month}-01`);
    const daysInMonth = firstDay.daysInMonth();
    const startWeekday = firstDay.day(); // 0 = Sunday

    const handleSelect = (day: number) => {
        const selected = dayjs(`${current.year()}-${month}-${day}`);
        if (selected.isValid()) {
            onChange?.(selected);
        }
    };

    // const goPrevMonth = () => setCurrent(current.subtract(1, 'month'));
    // const goNextMonth = () => setCurrent(current.add(1, 'month'));

    const goPrev = () => {
        setCurrent(mode === 'yyy-mm' ? current.subtract(1, 'year') : current.subtract(1, 'month'));
    };

    const goNext = () => {
        setCurrent(mode === 'yyy-mm' ? current.add(1, 'year') : current.add(1, 'month'));
    };

    const renderGrid = () => {
        if (mode === 'yyy-mm') {
            return Array.from({ length: 12 }, (_, i) => {
                const monthValue = i + 1;
                return (
                    <Button
                        key={monthValue}
                        className="grid-cell"
                        onClick={() => {
                            const selected = dayjs(`${current.year()}-${String(monthValue).padStart(2, '0')}-01`);
                            onChange?.(selected);
                        }}
                    >
                        {`${monthValue} 月`}
                    </Button>
                );
            });
        }

        const grid = [];
        for (let i = 0; i < startWeekday; i++) {
            grid.push(<div key={`empty-${i}`} className="grid-cell empty" />);
        }
        for (let d = 1; d <= daysInMonth; d++) {
            grid.push(
                <Button
                    key={d}
                    className="grid-cell"
                    onClick={() => handleSelect(d)}
                >
                    {String(d).padStart(2, '0')}
                </Button>
            );
        }
        return grid;
    };

    useEffect(() => {
        if (dayjs.isDayjs(value) && value.isValid()) {
            setCurrent(value);
        }
    }, [value]);

    return (
        <div className="roc-picker">
            {/*<div className="header">*/}
            {/*    <Button size="small" onClick={goPrev}>◀</Button>*/}
            {/*    <div className="month-label">{`民國 ${rocYear} 年 ${month} 月`}</div>*/}
            {/*    <Button size="small" onClick={goNext}>▶</Button>*/}
            {/*</div>*/}
            <div className="header">
                <Button size="small" onClick={goPrev}>◀</Button>
                <div className="month-label">
                    {mode === 'yyy-mm' ? `民國 ${rocYear} 年` : `民國 ${rocYear} 年 ${month} 月`}
                </div>
                <Button size="small" onClick={goNext}>▶</Button>
            </div>
            {mode !== 'yyy-mm' && (
                <div className="weekday-row">
                    {weekdays.map((w) => (
                        <div key={w} className="weekday-cell">{w}</div>
                    ))}
                </div>
            )}
            <div className="grid-container">{renderGrid()}</div>
        </div>
    );
};

export default RocDateGridPicker;
